var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "arrow-right_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6H.5M7.5 2l4 4-4 4"
  }))));
}

export default SvgArrowRight;